import { useEffect, useState } from 'react';

import { LinearProgress } from '@mui/material';
import { RouteComponentProps, useParams, useLocation } from 'react-router-dom';

import { fetchUser } from 'api';
import { useUserContext } from 'hooks';
import { useSnackContext } from 'hooks/useSnackContext';
import { AdminUserEditForm } from 'pages/user/AdminUserEditForm';
import { UserProps } from 'types';

import { UserEditForm } from './UserEditForm';

export interface Props
  extends RouteComponentProps<{
    user_id: string;
  }> {}

export const UserPage = () => {
  const { setSnack } = useSnackContext();
  const { user } = useUserContext();
  const { user_id } = useParams<{ user_id: string }>();
  const [thisUser, setThisUser] = useState<UserProps | null>(null);
  const [userRefresh, setUserRefresh] = useState(true);
  const [mounted, setMounted] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setMounted(true);
    async function fetchTheUser() {
      try {
        const { data } = await fetchUser(parseInt(user_id, 10));
        setThisUser(data);
      } catch (e) {
        setSnack((props) => ({
          ...props,
          severity: 'error',
          open: true,
          message: 'Failed to Fetch User',
          error: e as Error,
        }));
      } finally {
        mounted && setUserRefresh(false);
      }
    }
    if (userRefresh) {
      fetchTheUser();
    }
    return () => setMounted(false);
  }, [user_id, setThisUser, location.state, userRefresh, setSnack, mounted]);
  if (!thisUser) {
    return <LinearProgress sx={{ width: '100%' }} />;
  }

  return user?.role === 'signer' || user?.role === 'system_admin' ? (
    <UserEditForm
      user={thisUser}
      setUser={setThisUser as React.Dispatch<React.SetStateAction<UserProps>>}
    />
  ) : (
    <AdminUserEditForm
      user={thisUser}
      setUser={setThisUser as React.Dispatch<React.SetStateAction<UserProps>>}
      setUserRefresh={setUserRefresh}
    />
  );
};
